import { BgImage } from "gbimage-bridge";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "./Button";
import { SafeHtmlParser } from "./SafeHtmlParser";

const SectionLayout1 = ({
	smallHeading,
	heading,
	body,
	button,
	backgroundImage,
}) => {
	return (
		<section className="py-5 py-lg-7">
			<Container>
				<Row>
					<Col>
						<BgImage
							image={
								backgroundImage?.localFile?.childImageSharp?.gatsbyImageData
							}
							className="position-relative px-4 py-lg-10"
							style={{
								borderRadius: "12px",
								backgroundSize: "cover",
								backgroundPosition: "center",
								overflow: "hidden",
							}}
						>
							<div
								style={{
									background:
										"linear-gradient(180deg, rgba(0, 18, 33, 0.00) 6.66%, #001221 95.38%), linear-gradient(0deg, rgba(0, 48, 75, 0.50) 0%, rgba(0, 48, 75, 0.50) 100%)",
								}}
								className="position-absolute w-100 h-100 start-0 top-0"
							></div>
							<Row
								style={{ zIndex: 2 }}
								className="py-md-7 py-lg-0 py-xl-7 py-5 justify-content-center position-relative"
							>
								<Col lg={12} className="text-white px-4">
									{smallHeading && (
										<h3 className=" text-white fs-2 half mb-0">
											{smallHeading}
										</h3>
									)}
									<h2 className="mb-4 display-3">{heading}</h2>
									<SafeHtmlParser htmlContent={body} />
									{button && (
										<Button
											width="w-100 w-md-auto"
											link={button.url}
											text={button.title}
											colour="#FFC107" // Yellow color for the button
											textColor="#000"
										/>
									)}
								</Col>
							</Row>
						</BgImage>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default SectionLayout1;
